import o from "react";
import $ from "react-markdown";
import j from "remark-gfm";
import q from "rehype-raw";
import { useTheme as z, Box as J } from "@chakra-ui/react";
import { getStylesForAllHeading as K } from "./mark-down-reader-util.js";
function Y({
  markDown: a,
  disableDefaultStyles: i = !1
}) {
  const {
    markdown: {
      paragraph: l,
      listItem: n,
      heading1Mobile: d,
      heading1Tablet: r,
      heading1Desktop: g,
      heading2Mobile: m,
      heading2Tablet: p,
      heading2Desktop: b,
      heading3Mobile: h,
      heading3Tablet: s,
      heading3Desktop: c,
      heading4Mobile: k,
      heading4Tablet: u,
      heading4Desktop: f,
      heading5Mobile: x,
      heading5Tablet: D,
      heading5Desktop: M,
      heading6Mobile: y,
      heading6Tablet: T,
      heading6Desktop: w
    },
    content: { spacingMedium: C },
    element: {
      spacingSmall: R,
      spacingMedium: S,
      spacingLarge: P
    },
    linkDefault: A,
    action: { primaryDefault: _, primaryHover: v },
    linkUnderline: B,
    background: { default: E, mid: H },
    tableMediumPadding: e,
    tableSmallPadding: t,
    text: { default: F },
    common: { common02Regular: G },
    border: I
  } = z(), L = {
    heading1: {
      mobile: d,
      tablet: r,
      desktop: g
    },
    heading2: {
      mobile: m,
      tablet: p,
      desktop: b
    },
    heading3: {
      mobile: h,
      tablet: s,
      desktop: c
    },
    heading4: {
      mobile: k,
      tablet: u,
      desktop: f
    },
    heading5: {
      mobile: x,
      tablet: D,
      desktop: M
    },
    heading6: {
      mobile: y,
      tablet: T,
      desktop: w
    }
  }, U = i ? {} : {
    p: {
      ...l,
      pb: P
    },
    "ul, ol": {
      px: C,
      pb: R
    },
    li: {
      ...n
    },
    a: {
      textDecoration: B,
      color: _,
      _hover: { textDecoration: "none", color: v },
      ...A
    },
    tr: {
      borderBottom: `1px solid ${I.default}`
    },
    th: {
      backgroundColor: H,
      px: t,
      py: e,
      textAlign: "left"
    },
    td: {
      backgroundColor: E,
      px: t,
      py: e,
      textAlign: "left"
    },
    tbody: {
      font: { ...G },
      color: F
    },
    ...K(L, S)
  };
  return /* @__PURE__ */ o.createElement(J, { sx: U }, /* @__PURE__ */ o.createElement(
    $,
    {
      remarkPlugins: [[j, { singleTilde: !1 }]],
      rehypePlugins: [q]
    },
    a
  ));
}
export {
  Y as MarkDownReader
};
